import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.PROD ? "production" : "development",
    release: import.meta.env.VITE_COMMIT_SHA || "dev",
    tracesSampleRate: 0.05,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

export { Sentry };
